export default "__VITE_ASSET__BqIHejIE__"